// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Planoscontas_UpdatePercentualInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for PUT /planoscontas/template/item/{id}/percentual
 *
 * Updates the percentage for a variable budget account item.
 */
import { registerContract } from './validate'

export interface Planoscontas_UpdatePercentualInput {
percentual: number
}

registerContract('Planoscontas_UpdatePercentualInput', {
  percentual: { type: 'number',  required: true },
})
